import { AxiosError } from 'axios'
import { DataTableController } from 'components/common'
import {
  PricingDataFilterForm,
  PricingDataTable,
  columns,
} from 'components/pricing'
import { FILTER_FIELD_PRICING } from 'components/pricing/pricingFilterForm'
import { usePageAccess, useQuery } from 'hooks'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import { exportPricingData, importPricingData } from 'utils/api/pricingApi'
import { filterEmptyValues } from 'utils/helpers'

const Pricing = () => {
  const [showFilter, setShowFilter] = useState(false)
  const [selectedColumns, setSelectedColumns] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const { isEditor } = usePageAccess()

  const { getQuery, setMultipleQueries } = useQuery()

  const toggleFilterForm = () => {
    setShowFilter(!showFilter)
  }

  // Will handle the file export funtionality with toast
  const handleExport = async () => {
    const filters = getQuery(FILTER_FIELD_PRICING)

    // if not filters found in URL
    if (!filters) {
      return toast.error('Filters are required to export data!', {
        duration: 3000,
      })
    }

    // filtering empty values and keys of filter
    const pricingFilter = filterEmptyValues(filters)

    // if filters are present with empty values
    if (Object.keys(pricingFilter).length <= 0) {
      return toast.error('Please select at least on filter to export data!', {
        duration: 3000,
      })
    }

    const loadingToast = toast.loading('Loading...', { duration: Infinity })

    try {
      await exportPricingData({ filters: pricingFilter })
      toast.success('File will be sent to you in email!', {
        id: loadingToast,
        duration: 3000,
      })
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error?.response?.data?.errors?.msg?.runningService) {
          return toast.error(error.response.data.errors.msg.runningService, {
            id: loadingToast,
            duration: 3000,
          })
        }
      }

      toast.error('Failed to export Pricing Data.', {
        id: loadingToast,
        duration: 3000,
      })
    }
  }

  useEffect(() => {
    const selectedColumnState = localStorage.getItem('pricingSelectedColumns')

    if (selectedColumnState) {
      setMultipleQueries({ cols: JSON.parse(selectedColumnState) })
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>ORMS Pricing</title>
      </Helmet>

      <DataTableController
        isEditor={isEditor}
        columns={columns}
        handleFilter={toggleFilterForm}
        showFilter={showFilter}
        handleImport={importPricingData}
        handleExport={handleExport}
        activeColumnKey="pricing"
        placeholder="Barcode, Store code and Aggregator code"
        defaultSelectedColumns={selectedColumns}
        loading={loading}
      />

      {showFilter ? (
        <PricingDataFilterForm toggleFilterForm={toggleFilterForm} />
      ) : (
        <PricingDataTable
          isEditor={isEditor}
          setSelectedColumns={setSelectedColumns}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </>
  )
}

export default Pricing
